module.exports = __webpack_public_path__ + "static/media/hal_btm_2.48f49022.png";